import { render } from "./GridVP.vue?vue&type=template&id=fba5f208"
import script from "./GridVP.vue?vue&type=script&lang=js"
export * from "./GridVP.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__